'use client';

import { PropsWithChildren, ReactNode } from 'react';
import logTrailDetailsShowMoreClicked from '@alltrails/amplitude/events/logTrailDetailsShowMoreClicked';
import useToggle from '@alltrails/core/hooks/useToggle';
import ExpandableText from '@alltrails/denali/components/ExpandableText';
import LocalizationButton from '@alltrails/layout/components/LocalizationButton';
import type TrailDetails from '@alltrails/types/TrailDetails';
import styles from './Description.module.scss';

type Props = {
  hideLocalizationButton?: boolean;
  isBot: boolean;
  isShortened?: boolean;
  source?: ReactNode;
  trailDetails: TrailDetails;
};

export default function Description({ children, hideLocalizationButton, isBot, isShortened, source, trailDetails }: PropsWithChildren<Props>) {
  const [showSource, toggleShowSource] = useToggle();

  return (
    <div>
      <ExpandableText
        maxLines={isShortened ? 3 : 5}
        expandOnLoad={isBot}
        onClick={() => logTrailDetailsShowMoreClicked({ trail_id: trailDetails.id, show_more_location: 'overview' })}
        className={styles.description}
        scrollMarginTop={184} // 184px is the height of the desktop CTA bar
      >
        {showSource ? source : children}
      </ExpandableText>
      {source && !hideLocalizationButton && (
        <LocalizationButton showSource={showSource} toggleShowSource={toggleShowSource} className={styles.source} />
      )}
    </div>
  );
}
